import React from 'react';
import InfoIcon from '@tradera/blueprint/theme/icons2/info.svg?jsx';
import styles from './info-tooltip.module.scss';

export const InfoTooltip = ({
    customIcon,
    className = '',
    containerClassName = '',
    children
}) => (
    <span className={`${styles.container} ${containerClassName}`}>
        <span className={styles.target} tabIndex="0">
            {customIcon || <InfoIcon className={`icon icon-md ${className}`} />}

            <span className={styles.arrow} />
        </span>
        <span className={styles.tooltip}>{children}</span>
    </span>
);
